import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import DataTable from '../components/DataTable';
import DataModal from '../components/DataModal';

const TABLE_NAME = 'rox_materials_1740635000';

const columns = [
  { key: 'item_name', label: 'Item Name' },
  { key: 'category', label: 'Category' },
  { key: 'sub_category_1', label: 'Sub Cat 1' },
  { key: 'sub_category_2', label: 'Sub Cat 2' },
  { key: 'stamina_cost', label: 'Stamina Cost' },
  { key: 'level', label: 'Level' },
  { key: 'location', label: 'Location' },
  { key: 'req_material', label: 'Req Material' },
  { key: 'req_mat_cost', label: 'Req Mat Cost' },
  { key: 'e_cost', label: 'Exchange Cost' }
];

const formFields = [
  { name: 'item_name', label: 'Item Name', type: 'text', required: true },
  { name: 'category', label: 'Category', type: 'text' },
  { name: 'sub_category_1', label: 'Sub Category 1', type: 'text' },
  { name: 'sub_category_2', label: 'Sub Category 2', type: 'text' },
  { name: 'stamina_cost', label: 'Stamina Cost', type: 'number' },
  { name: 'level', label: 'Level', type: 'number' },
  { name: 'location', label: 'Location', type: 'text' },
  { name: 'req_material', label: 'Required Material', type: 'text' },
  { name: 'req_mat_cost', label: 'Required Material Cost', type: 'number' },
  { name: 'e_cost', label: 'Exchange Cost', type: 'number' }
];

export default function Materials() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const fetchData = async () => {
    setIsLoading(true);
    const { data: mats, error } = await supabase
      .from(TABLE_NAME)
      .select('*')
      .order('item_name', { ascending: true });
    
    if (!error && mats) setData(mats);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async (formData) => {
    const { error } = await supabase
      .from(TABLE_NAME)
      .upsert(formData, { onConflict: 'item_name' });

    if (!error) {
      fetchData();
      setIsModalOpen(false);
    } else {
      alert('Error saving data: ' + error.message);
    }
  };

  const handleDelete = async (row) => {
    if (window.confirm(`Are you sure you want to delete "${row.item_name}"?`)) {
      const { error } = await supabase
        .from(TABLE_NAME)
        .delete()
        .eq('item_name', row.item_name);
      
      if (error) {
        alert('Error deleting item: ' + error.message);
      } else {
        fetchData();
      }
    }
  };

  const openAddModal = () => {
    setEditingItem(null);
    setIsModalOpen(true);
  };

  const openEditModal = (item) => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  return (
    <>
      <DataTable 
        title="Materials" 
        columns={columns} 
        data={data} 
        isLoading={isLoading} 
        onAdd={openAddModal} 
        onEdit={openEditModal}
        onDelete={handleDelete}
      />
      <DataModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onSave={handleSave} 
        fields={formFields} 
        initialData={editingItem} 
        title={editingItem ? 'Edit Material' : 'Add Material'} 
      />
    </>
  );
}